import { fetch } from "@/api/fetch-auto-refresh";
import { useStore } from "@/store";
import { errorMessage } from "@/composables/use-admin-list";

const request = async (path = "", body) => {
  try {
    const response = await fetch(
      `${process.env.VUE_APP_API_URL}/v1/users/deactivation-jobs${path}`,
      {
        method: body ? "POST" : "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${useStore().state.auth.token}`
        },
        ...(body ? { body: JSON.stringify(body) } : {})
      }
    );
    const text = await response.text();
    // Older APIs send an empty success response when no job exists.
    if (!text.trim() && !path && !body && response.ok) return null;
    let data;
    try {
      data = JSON.parse(text);
    } catch (error) {
      throw new Error(
        "Unable to read the deactivation response. Please try again."
      );
    }
    if (!response.ok)
      throw new Error(
        (data && data.message) || "Unable to process deactivation."
      );
    return data;
  } catch (error) {
    throw new Error(errorMessage(error));
  }
};
export const previewDeactivation = body => request("", body);
export const startDeactivation = (id, confirmation) =>
  request(`/${id}/start`, { confirmation });
export const getDeactivationJob = id => request(`/${id}`);
export const getLatestDeactivation = () => request();
